import { useTranslation } from "react-i18next";
import { featuredItems } from "@/mocks/featured";

export default function FeaturedSpreadsheet() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4">
            {t("home:featuredTitle", "Top Product Finds")} <span className="inline-block">📊</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t("home:featuredSubtitle", "Discover the most popular categories with thousands of verified product links")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredItems.map((item, i) => (
            <a
              key={i}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all hover:bg-background-200/60"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: "4/5" }}>
                <img
                  src={item.image}
                  alt={item.category}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3">
                  <span className="px-3 py-1 rounded-full bg-white/80 backdrop-blur-sm text-foreground-900 text-xs font-semibold whitespace-nowrap">
                    {item.products} links
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col gap-2 flex-1">
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                  {item.category}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.description}
                </p>
                <div className="flex items-center justify-between mt-2 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-500">
                    Updated {item.updated}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                    {item.popularity} demand <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}